/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CheckUsageDto } from '../common/check-usage.dto';
import { CheckUsageMapper } from '../common/check-usage.mapper';
import { InspectionItemDto, SiteDetailsDto, SiteListDto, SiteListItemDto } from './site.dto';
import { SiteDetailsMapper, SiteListMapper } from './site.mapper';

@Injectable()
export class SiteRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  init(sfId: ID): Observable<InspectionItemDto[]> {
    return this.httpGet(`${this.bp}/leads/sales-folders/${sfId}/sites/init`, identity());
  }

  create(sfId: ID, site: SiteDetailsDto): Observable<SiteDetailsDto> {
    return this.httpPost(`${this.bp}/leads/sales-folders/${sfId}/sites/`, site, SiteDetailsMapper);
  }

  get(sfId: ID, siteId: ID): Observable<SiteDetailsDto> {
    return this.httpGet(`${this.bp}/leads/sales-folders/${sfId}/sites/${siteId}`, SiteDetailsMapper);
  }

  checkUsage(sfId: ID, site: SiteListItemDto): Observable<CheckUsageDto> {
    return this.httpGet(
      `${this.bp}/leads/sales-folders/${sfId}/sites/${site.id}/check-usage`,
      { version: site.version },
      void 0,
      CheckUsageMapper);
  }

  findAll(sfId: ID): Observable<SiteListDto> {
    return this.httpGet(`${this.bp}/leads/sales-folders/${sfId}/sites`, SiteListMapper);
  }

  remove(sfId: ID, siteId: ID): Observable<CheckUsageDto> {
    return this.httpDelete(`${this.bp}/leads/sales-folders/${sfId}/sites/${siteId}`, void 0, CheckUsageMapper);
  }

  update(sfId: ID, site: SiteDetailsDto): Observable<SiteDetailsDto> {
    return this.httpPut(`${this.bp}/leads/sales-folders/${sfId}/sites/${site.id}`, site, SiteDetailsMapper);
  }
}
